import { render, staticRenderFns } from "./detail-pay.vue?vue&type=template&id=4a17f350&scoped=true&"
import script from "./detail-pay.vue?vue&type=script&lang=js&"
export * from "./detail-pay.vue?vue&type=script&lang=js&"
import style0 from "./detail-pay.vue?vue&type=style&index=0&id=4a17f350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a17f350",
  null
  
)

export default component.exports